/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'geo-marker': {
    width: 12,
    height: 16,
    viewBox: '0 0 12 16',
    data: '<path pid="0" d="M5.625 3.75c-1.034 0-1.875.84-1.875 1.875 0 1.039.84 1.875 1.875 1.875A1.87 1.87 0 007.5 5.625c0-1.034-.84-1.875-1.875-1.875z" _fill="#6D9AE8"/><path pid="1" d="M5.625 0A5.631 5.631 0 000 5.625c0 1.048.29 2.07.84 2.958l4.465 7.195c.185.3.621.295.8-.006l4.352-7.265A5.626 5.626 0 005.625 0zm0 8.444a2.82 2.82 0 01-2.819-2.819 2.826 2.826 0 012.819-2.819 2.818 2.818 0 110 5.637z" _fill="#6D9AE8"/>'
  }
})
